import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import {
	RegistrationState,
	VehicleType
} from "store/features/registration/types";
import { Requester } from "./requester";

export const getVehicles = async (partner_id: string | null = "") => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partner_id}/vehicle/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getVehicleModels = async () => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/vehicle-model/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getVehicle = async (
	partnerId: string | null = "",
	vehicleId: string | null = ""
) => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partnerId}/vehicle/${vehicleId}/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getVehiclePhoto = async (
	partnerId: string | null = "",
	vehicleId: string | null = ""
) => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/vehicle/${vehicleId}/photo/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return result.results;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getVehicleDocument = async (
	partnerId: string | null = "",
	vehicleId: string | null = ""
) => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/vehicle/${vehicleId}/document/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return result.results;
		},
		error: (error) => {
			throw error;
		}
	});
};

export interface VehicleResponse {
	id: string;
}

export const createOrUpdateVehicle = async (
	partner_id: string | null,
	vehicle_id: string | null,
	vehicle: VehicleType
) => {
	const access_token = await getAccessToken();

	const requestData = { ...vehicle };

	if (!vehicle_id) {
		return Requester.post({
			url: `${baseConfig.baseURL}/partner/${partner_id}/vehicle/`,
			token: `${access_token}`,
			tokenType: "Bearer",
			body: requestData,
			success: (result): VehicleResponse => {
				return result;
			},
			error: (error) => {
				throw error;
			}
		});
	}

	return Requester.put({
		url: `${baseConfig.baseURL}/partner/${partner_id}/vehicle/${vehicle_id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): VehicleResponse => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const uploadVehiclePhoto = async (
	vehicle_id: string,
	file: File,
	title: string
) => {
	const access_token = await getAccessToken();
	const formData = new FormData();
	formData.append("image", file);
	formData.append("title", title);

	return Requester.postFormData({
		url: `${baseConfig.baseURL}/vehicle/${vehicle_id}/photo/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: formData,
		success: (result) => result,
		error: (error) => {
			throw error;
		}
	});
};

export const uploadVehicleDocument = async (
	vehicle_id: string,
	file: File,
	document_type: string
) => {
	const access_token = await getAccessToken();
	const formData = new FormData();
	formData.append("file", file);
	formData.append("document_type", document_type);

	return Requester.postFormData({
		url: `${baseConfig.baseURL}/vehicle/${vehicle_id}/document/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: formData,
		success: (result) => result,
		error: (error) => {
			throw error;
		}
	});
};

/*
export const saveVehicle = async (
	personalData: RegistrationState,
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	const requestData = { ...personalData };

	return Requester.put({
		url: `${baseConfig.baseURL}/vehicle/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
*/

export const deleteVehicle = async (
	partner_id: string | null = "",
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	return Requester.delete({
		url: `${baseConfig.baseURL}/partner/${partner_id}/vehicle/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
